export default __webpack_public_path__ + "static/media/programmer.b73acdfd.svg";